import React from "react";
import { Trash } from "lucide-react";

const ReviewList = ({ reviews, properties, user, handleDelete, t }) => {
  const renderStars = (rating) => "⭐".repeat(rating);

  if (!reviews || reviews.length === 0) {
    return <p style={styles.noReviews}>{t("noReviews")}</p>;
  }

  return (
    <div style={styles.gridContainer}>
      {reviews.slice(0, 4).map((r)  => {
        const property = properties.find((p) => p.property_id === r.property_id);
        const propertyName = property?.name || t("noProperty") || "No property";

        return (
          <div
            key={r.id}
            style={styles.card}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <div style={styles.propertyName}>{propertyName}</div>

            <div style={styles.cardHeader}>
              <strong style={styles.reviewerName}>{r.reviewer_name || "-"}</strong>
              {user?.role?.toLowerCase() === "admin" && (
                <button onClick={() => handleDelete(r.id)} style={styles.deleteButton}>
                  <Trash size={18} />
                </button>
              )}
            </div>

            <div style={styles.ratingText}>
              {t("rating")}: <span style={styles.stars}>{renderStars(r.rating || 0)}</span>
            </div>

            <p style={styles.reviewText}>{r.review_text || "-"}</p>

            {r.images && r.images.length > 0 && (
              <div style={styles.imageContainer}>
                {r.images.map((img, idx) => (
                  <img key={idx} src={img} alt="review" style={styles.image} />
                ))}
              </div>
            )}

            <small style={styles.dateText}>
              {r.created_at ? new Date(r.created_at).toLocaleDateString() : "-"}
            </small>
          </div>
        );
      })}
    </div>
  );
};

export default ReviewList;

// 🎨 Styles สำหรับ ReviewList
const styles = {
  gridContainer: {
    display: "grid",
    gap: "1rem",
    padding: "1rem 0",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  },
  card: {
    minHeight: "300px",
    border: "1px solid #eee",
    padding: "20px",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
    transition: "transform 0.2s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  propertyName: {
    marginBottom: "6px",
    fontWeight: "600",
    color: "#1a2e35",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  reviewerName: {
    fontSize: "1rem",
    color: "#0a71e7",
  },
  deleteButton: {
    background: "none",
    border: "none",
    color: "red",
    cursor: "pointer",
  },
  ratingText: {
    marginBottom: "6px",
    color: "#333",
  },
  stars: {
    fontWeight: "600",
    color: "#ff9500",
  },
  reviewText: {
    color: "#555",
    marginBottom: "8px",
  },
  imageContainer: {
  display: "flex",
  gap: "8px",
  flexWrap: "wrap",
  marginBottom: "8px",
  alignItems: "center",
  justifyContent: "center"
},
  image: {
    width: "100%",
    maxWidth: "285px",
    height: "250px",
    objectFit: "cover",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },
  dateText: {
    color: "#999",
  },
  noReviews: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "#777",
    minHeight: "40vh",
    width: "100%",
  },
};
